import { CheckName } from 'dashboard/models/check/check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';
import { CountryCode } from 'lib/constants/locales';

export type AgeLimitCheckName = CheckName.IdAgeComparison;

export interface AgeLimitConfig {
  'country-code': CountryCode | 'default' | null;
  'max-age': number | null;
  'min-age': number | null;
}

export interface AgeLimitCheckConfig extends VerificationCheckConfig {
  check: AgeLimitCheckName;
  'age-limits': AgeLimitConfig[];
}

export function isAgeLimitCheck(
  verificationCheck: VerificationCheckConfig,
): verificationCheck is AgeLimitCheckConfig {
  switch (verificationCheck.check) {
    case CheckName.IdAgeComparison:
      return true;
    default:
      return false;
  }
}
